package com.xtream.data_kmp.db.tables

import androidx.room3.ColumnInfo
import androidx.room3.Embedded
import androidx.room3.Entity
import com.xtream.data_kmp.dto.CategoryBase
import com.xtream.data_kmp.dto.LiveCategory
import com.xtream.data_kmp.dto.SeriesCategory
import com.xtream.data_kmp.dto.VodCategory
import kotlin.time.Clock


enum class StreamType {
    LIVE,
    MOVIE,
    SERIES
}
/**
 * Categories the user has chosen to hide from their channel/movie/series list.
 * Presence of a row = hidden. No row = visible (default).
 *
 * categoryId is only unique WITHIN a type — Live category 5 and Movie category 5
 * are unrelated, so type is part of the primary key.
 */
@Entity(
    tableName = "hidden_categories",
    primaryKeys = ["categoryId", "type"]
)
data class HiddenCategoryEntity(
    val categoryId: Int,
    val type: StreamType,
    val hiddenAt: Long =  Clock.System.now().toEpochMilliseconds()

)

fun CategoryBase.toHiddenCategoryEntity(  type: StreamType):HiddenCategoryEntity {
  return  HiddenCategoryEntity(
        categoryId= categoryId?:-1,
        type = type
    )
}
interface CategoryWithVisibleStatus<T> {
    val category: T
    val isHidden: Boolean
}

data class LiveCategoryWithVisibleStatus(
    @Embedded
    override val category: LiveCategory,
    @ColumnInfo(name = "isHidden")
    override val isHidden: Boolean
) : CategoryWithVisibleStatus<LiveCategory>

data class VodCategoryWithVisibleStatus(
    @Embedded
    override val category: VodCategory,
    @ColumnInfo(name = "isHidden")
    override val isHidden: Boolean
) : CategoryWithVisibleStatus<VodCategory>

data class SeriesCategoryWithVisibleStatus(
    @Embedded
    override val category: SeriesCategory,
    @ColumnInfo(name = "isHidden")
    override val isHidden: Boolean
) : CategoryWithVisibleStatus<SeriesCategory>